import { render, staticRenderFns } from "./ClaimExpiration.vue?vue&type=template&id=20b61d6f&scoped=true&"
import script from "./ClaimExpiration.vue?vue&type=script&lang=js&"
export * from "./ClaimExpiration.vue?vue&type=script&lang=js&"
import style0 from "./ClaimExpiration.vue?vue&type=style&index=0&id=20b61d6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b61d6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b61d6f')) {
      api.createRecord('20b61d6f', component.options)
    } else {
      api.reload('20b61d6f', component.options)
    }
    module.hot.accept("./ClaimExpiration.vue?vue&type=template&id=20b61d6f&scoped=true&", function () {
      api.rerender('20b61d6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/ClaimExpiration.vue"
export default component.exports